import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import { finalize, publishReplay, refCount } from 'rxjs/operators';
//import { TranslateService } from '@ngx-translate/core';
import { AccountService, ICoupon } from 'src/app/account/services/account.service';
import { ToastController } from '@ionic/angular';
import { LoaderService } from './loader.service';
import { PageService } from 'src/app/services/page.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { AlertService } from './alert.service';
import { SettingService } from './setting.service';
import { ApiControllerService } from './api-controller.service';


@Injectable({
    providedIn: 'root'
})

export class CouponService {

    constructor(
                //private translate: TranslateService,
                private alertService: AlertService,
                private http: HttpClient,
                private setting: SettingService,
                private accountService: AccountService,
                private page: PageService,
                private auth: AuthService,
                private loader: LoaderService,
                private apiController: ApiControllerService  
                )
                { }

                /*processing part of the service (usually this logic go in a component, but to reuse it in
                app component and coupon component, we put it here */
                processCouponAvailability() {
                    let linkedCoupons;
                    let redeemedCoupons;
                    let linkedCouponsArr = [];
                    let availableCoupons = [];
                    let redeemedCouponsArr = [];

                    this.getAvailableCoupons().subscribe(coupons => {

                        //debugger;
                        coupons.forEach((item) => {
                            // fetch stored coupons
                            linkedCoupons = localStorage.getItem('linkCoupon');
                            redeemedCoupons = localStorage.getItem('redeemedCoupon');
                           
                            if(!linkedCoupons || linkedCoupons == 'undefined') {
                                // no coupons linked init empty array
                                linkedCouponsArr = [];
                            }

                            if(!redeemedCoupons || redeemedCoupons == 'undefined') {
                                // no coupons linked init empty array
                                redeemedCouponsArr = [];
                            }

                            if(typeof linkedCoupons == 'string') {
                                // some coupons already linked, convert to array
                                linkedCouponsArr = JSON.parse(linkedCoupons)
                            }

                            if(typeof redeemedCoupons == 'string') {
                                // some coupons already redeemed, convert to array
                                redeemedCouponsArr = JSON.parse(redeemedCoupons)
                            }

                            for(let i = 0; i <= linkedCouponsArr.length; i++) {
                                if(parseInt(linkedCouponsArr[i]) == item.Id) {
                                    //coupon linked already, no need to link
                                    break;
                                } else {
                                    if(linkedCouponsArr.length == 0 || i == linkedCouponsArr.length - 1) {
                                        // coupon not found, link (& save in local storage)
                                         this.accountService.linkCoupons(item.Id)
                                             .subscribe(res => {
                                                 if(res == null || res == "4") {
                                                     //4 is the code for a coupon reached its usage
                                                     // nothing is returned?
                                                     //coupon is already used, remove it from the list
                                                     //check first if the coupon id is not already redeemed
                                                    let found = false;
                                                    for (let i = 0; i < redeemedCouponsArr.length; i++) {
                                                        if (redeemedCouponsArr[i] == item.Id) {
                                                            found = true;
                                                        }
                                                    }

                                                    if (!found) {
                                                        redeemedCouponsArr.push(item.Id);
                                                        localStorage.setItem('redeemedCoupon', JSON.stringify(redeemedCouponsArr));
                                                    }
                                                   
                                                    
                                                 } else {
                                                    linkedCouponsArr.push(item.Id)
                                                    localStorage.setItem('linkCoupon', JSON.stringify(linkedCouponsArr));
                                                 }
                                             })
                                    }  
                                }
                                
                            }                       
                            
                            // Get Coupon Details
                            this.accountService.GetDetailedCoupons(item.Id)
                                .subscribe(res => {
                                    if(res == null) {
                                        // coupon is expired, don't add to available coupons
                                        console.log('coupon no longer valid')
                                    } else {
                                        // Coupon valid
                                        availableCoupons.push(item);
                                    }
                                })
                             
                            });
                        });
                    return availableCoupons;
                }

               /*this is where the service start for real*/

               getAvailableCoupons(): Observable<ICoupon[]> {
                let availableCoupons = [];
                let headers = {};
                this.page.appendAuthorizationHeader(headers);
            
                return Observable.create(o => {
                  /* this.http.get(this.setting.getLegacySmaUrl('V2/page/GetECoupons'), {
                    headers: headers
                  })
                    .pipe(finalize(() => {
                      o.complete();
                    }))
                    .subscribe(
                      result => {
                        console.log(result)
                        o.next(result);
                      },
                      res => {
                        this.alertService.showUnexpectedErrorMsg();
                        o.error(res);
                      }
                    ); */
                this.apiController.get(this.setting.getLegacySmaUrl('V2/page/GetECoupons'), {
                    headers: headers
                  })
                    .pipe(finalize(() => {
                      o.complete();
                    }))
                    .subscribe(
                      result => {
                        console.log(result)
                        o.next(result);
                      },
                      res => {
                        this.alertService.showUnexpectedErrorMsg();
                        o.error(res);
                      }
                    );
                })
                    
                    
        }
                
}